import { StandardBlocksLayout } from 'components/general/standardBlocksLayout/StandardBlocksLayout';
import { useEffect, useState } from 'react';
import { getData } from 'utils/helpers';
import ContentLoader from './ContentLoader';
import { ProjectType } from 'pages/project/[id]/index';

type Props = { projectEndpoint: string; blockClassNames: string; loaderClassName: string };
const ProjectContent = ({ projectEndpoint, blockClassNames, loaderClassName }: Props) => {
  const [data, setData] = useState<ProjectType | undefined>(undefined);

  useEffect(() => {
    //TODO: kill the fetch on Unmount!!
    async function fetchData() {
      const json = await getData(projectEndpoint);
      json.blocks.forEach((block) => {
        if (block.block_type === 'media') {
          block.loadColor = '#EFEFEF';
        }
        if (block.block_type === 'gallery') {
          block.items.forEach((item) => {
            item.loadColor = '#EFEFEF';
          });
        }
      });

      setData(json);
    }
    fetchData();
  }, [projectEndpoint]);

  if (data) return <StandardBlocksLayout blocks={data.blocks} blockStyles={blockClassNames} />;
  return <ContentLoader />;
};

export default ProjectContent;
